import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setRoles, setLoading, setError } from '../../redux/role/roleSlice';
import fetchRoles from '../../redux/role/roleService';
import { Role } from '../../redux/role/roleTypes';

const RoleManager: React.FC<any> = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token) {
      dispatch(setLoading(false));
      return;
    }

    const getRoles = async () => {
      dispatch(setLoading(true));

      try {
        if (token) {
          const roles: Role[] = await fetchRoles(dispatch);
          if (roles && (roles as any)?.message) {
            dispatch(setError((roles as any).message));
          } else {
            dispatch(setRoles(roles));
          }
          dispatch(setLoading(false));
        }
      } catch (error) {
        console.error('Failed to fetch roles:', error);
        dispatch(setError(error instanceof Error ? error.message : 'Unknown error occurred'));
        dispatch(setLoading(false));
      }
    };

    getRoles();
  }, [dispatch]);

  return null;
};

export default RoleManager;
